import { createI18n } from 'vue-i18n'
import enMessages from './en.json'
import deMessages from './de.json'

export { default as en } from './en.json'
export { default as de } from './de.json'

const SUPPORTED = ['en', 'de'] as const
type Lang = (typeof SUPPORTED)[number]

/** Pick the initial UI language from the browser, falling back to English. */
function detectLocale(): Lang {
  const nav = typeof navigator !== 'undefined' ? navigator.language : ''
  const short = (nav || 'en').slice(0, 2).toLowerCase()
  return (SUPPORTED as readonly string[]).includes(short) ? (short as Lang) : 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en: enMessages, de: deMessages },
})
